var _circle, _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 73,
    viewBox: "0 0 104 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 36.5,
    r: 36.266,
    fill: "url(#paint0_linear_506_3342)",
    stroke: "#81A9D7",
    strokeWidth: 0.467949
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5165 21.6545C77.5894 21.612 77.663 21.569 77.7374 21.5256C78.3617 21.1614 78.9668 20.8454 79.5552 20.5751C82.2679 25.2587 83.8207 30.698 83.8207 36.5C83.8207 54.074 69.5742 68.3205 52.0002 68.3205C34.4262 68.3205 20.1797 54.074 20.1797 36.5C20.1797 31.6712 21.2553 27.0936 23.18 22.9937C23.5112 23.1038 23.838 23.2148 24.1612 23.3245C28.3328 24.7409 31.9026 25.953 36.5579 22.4615C44.0451 16.8461 52.9361 17.3141 61.8271 21.5256C70.6091 25.6855 71.6497 25.0782 77.5165 21.6545Z",
    fill: "url(#paint1_linear_506_3342)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_506_3342)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 35.5,
    rx: 41.5,
    ry: 16.5,
    fill: "#FA4131",
    fillOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.42 33.684H43.656V38.076H42.42V33.684ZM40.224 34.212H41.436V37.776H40.224V34.212ZM44.232 35.148V34.02H49.608V35.076C49.352 35.732 48.872 36.288 48.168 36.744C48.76 36.976 49.436 37.18 50.196 37.356L49.524 38.424C48.508 38.104 47.648 37.748 46.944 37.356C46.36 37.58 45.684 37.776 44.916 37.944L45.48 38.364C44.88 38.772 44.256 39.132 43.608 39.444L45.684 39.324C46.204 39.036 46.668 38.772 47.076 38.532L48.132 39.228C46.756 40.012 45.268 40.652 43.668 41.148C45.076 41.084 46.456 41.012 47.808 40.932C47.592 40.708 47.368 40.496 47.136 40.296L48.108 39.696C48.988 40.464 49.704 41.176 50.256 41.832L49.248 42.516C49.064 42.276 48.844 42.016 48.588 41.736C47.588 41.808 46.62 41.868 45.684 41.916V43.572C45.684 44.332 45.304 44.712 44.544 44.712H43.416L43.152 43.536C43.544 43.592 43.868 43.62 44.124 43.62C44.316 43.62 44.412 43.504 44.412 43.272V41.988L40.368 42.156L40.116 41.04C40.476 41.064 40.836 41.076 41.196 41.076C42.06 40.884 42.972 40.584 43.932 40.176C42.74 40.24 41.828 40.292 41.196 40.332L40.98 39.288C41.508 39.288 41.884 39.244 42.108 39.156C42.78 38.836 43.524 38.388 44.34 37.812L43.908 37.02C44.628 36.9 45.264 36.756 45.816 36.588C45.288 36.132 44.904 35.652 44.664 35.148H44.232ZM46.944 36.156C47.552 35.876 48.016 35.54 48.336 35.148H45.792C46.056 35.516 46.44 35.852 46.944 36.156ZM46.848 42.192C48.08 42.56 49.22 43.012 50.268 43.548L49.608 44.604C48.536 43.98 47.412 43.484 46.236 43.116L46.848 42.192ZM43.632 43.056C42.72 43.64 41.568 44.14 40.176 44.556L39.636 43.428C40.94 43.124 42.024 42.72 42.888 42.216L43.632 43.056ZM60.924 40.788H52.92V39.684H59.712V39.072H53.376V38.016H59.712V37.404H52.968C52.76 37.564 52.528 37.724 52.272 37.884L51.48 36.924C52.848 36.108 54.04 34.964 55.056 33.492L56.316 33.78C56.148 34.012 56.016 34.208 55.92 34.368H59.592V35.22C59.304 35.604 59.008 35.964 58.704 36.3H60.924V40.788ZM57.18 36.3C57.444 36.06 57.736 35.76 58.056 35.4H55.116C54.812 35.744 54.532 36.044 54.276 36.3H57.18ZM53.988 41.556C53.676 42.668 53.24 43.628 52.68 44.436L51.6 43.752C52.144 42.992 52.532 42.176 52.764 41.304L53.988 41.556ZM55.764 44.592C54.924 44.592 54.504 44.168 54.504 43.32V41.244H55.752V43.044C55.752 43.332 55.876 43.476 56.124 43.476H58.452C58.636 43.476 58.78 43.424 58.884 43.32C58.996 43.208 59.072 42.84 59.112 42.216L60.3 42.612C60.204 43.572 60.024 44.148 59.76 44.34C59.52 44.508 59.16 44.592 58.68 44.592H55.764ZM57.36 40.86C57.904 41.404 58.332 41.888 58.644 42.312L57.6 43.032C57.272 42.544 56.848 42.032 56.328 41.496L57.36 40.86ZM60.9 41.016C61.62 41.976 62.18 42.82 62.58 43.548L61.536 44.28C61.112 43.448 60.564 42.572 59.892 41.652L60.9 41.016Z",
    fill: "#112C56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_506_3342",
    x: 0.0179482,
    y: 8.51795,
    width: 103.964,
    height: 53.9641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.24103,
    result: "effect1_foregroundBlur_506_3342"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_3342",
    x1: 52,
    y1: 0,
    x2: 52,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10234E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16547B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_3342",
    x1: 83.8207,
    y1: 36.868,
    x2: 20.1797,
    y2: 36.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491939,
    stopColor: "#FA4131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.9fa08faa72eaaccf52e28b7d416675d4.svg";
export { ForwardRef as ReactComponent };